import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import './editEventModal.scss'
import { useEffect, useState } from 'react';
import { DialogActions, MenuItem, TextField, } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import { useNavigate } from 'react-router-dom';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks/hooks';
import AdminApi from '../../../../../store/services/admin';
import { StudentActions, getEvents } from '../../../../../store/StudentAction';
import { createNotifictions } from '../../../../../utils/helperFunction';
import AutoCompletePeople from '../../newMeetingModal/autoComplete/autoComplete';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditEVentModal(props: any) {
    const [open, setOpen] = React.useState(false)
    const [eventName, setEventName] = useState(props.event.details.title)
    const [location, setLocation] = useState(props.event.details.location)
    const [meetingUrl, setMeetingUrl] = useState(props.event.details.meetingUrl)
    const userDetails = useAppSelector((state: any) => state.user.user)
    const studentsList = useAppSelector((state: any) => state.admin.placements)
    const [participantList, setPartcipantList] = useState<any[]>([]);
    const events = useAppSelector((state: any) => state.admin.events)
    const [from, setFrom] = React.useState<Dayjs | null>(
        dayjs(new Date(props.event.details.From)),
    );
    const [to, setTo] = React.useState<Dayjs | null>(
        dayjs(props.event.details.To),
    );
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const reset = () => {
        setFrom(dayjs(new Date()))
        setTo(dayjs(new Date()))
        setLocation("")
        setMeetingUrl("")
        setEventName("")
        setPartcipantList([])
    }
    const assignValue = () => {
        setFrom(dayjs(new Date(props.event.details.From)))
        setTo(dayjs(new Date(props.event.details.To)))
        setLocation(props.event.details.location)
        setMeetingUrl(props.event.details.meetingUrl)
        setEventName(props.event.details.title)
        setPartcipantList(props.event.details.participants)
    }
    const checkEvent = () => {
        return events.filter((elm: any) => {
            return elm.details.title === eventName && elm.details.location === location && dayjs(elm.details.From).format('LLL').toString() === dayjs(from?.toString()).format('LLL').toString() && dayjs(elm.details.To).format('LLL').toString() === dayjs(to?.toString()).format('LLL').toString() && JSON.stringify(elm.details.participants) === JSON.stringify(participantList)
        })
    }
    const handleSubmit = async (e: any) => {
        if (checkEvent().length > 0) {
            dispatch(StudentActions.setMessage(`${props.event.details.title} event already exists.`))
        }
        else {
            setIsLoading(true)
            e.preventDefault()
            const editEvent = Object.keys(props.event) && props.event as any
            let body = {
                EventType: "TM",
                userId: userDetails.result.Id,
                id: editEvent._id,
                details: {
                    dateApplied: new Date(),
                    From: from,
                    To: to,
                    location: location,
                    meetingUrl: meetingUrl,
                    title: eventName,
                    participants: [{ ...userDetails.result }, ...participantList],
                    rejectedParticipants: [],
                    acceptedParticipants: [userDetails.result.Id]
                }
            }
            AdminApi.newEventRequest(body).then(async res => {
                dispatch(StudentActions.setMessage("Meeting Generated"))
                participantList.forEach((elm: any) => {
                    createNotifictions({
                        target: elm.Student_ID,
                        message: `${eventName} meeting was Edited by ${userDetails.result.first_name} ${userDetails.result.last_name} `,
                        type: "TM",
                        eventId: res.data._id
                    })
                })
                props.editEventComplete()
                await dispatch(getEvents("all"))
                setIsLoading(false)
            }).catch((e) => {
                console.log(e)
                if (e.response.status === 403) {
                    navigate('/login')
                }
                setIsLoading(false)
                reset()
                dispatch(StudentActions.setMessage("Meeting Generation Failed.Try again."))
            })
        }

    }
    useEffect(() => {
        reset()
        handleClose()
    }, [isLoading])
    useEffect(() => {
        assignValue()
    },[props.event])
    return (
        <div>
            <MenuItem onClick={() => {
                if (props.event.details.acceptedParticipants.length > 1) {
                    dispatch(StudentActions.setMessage(`${props.event.details.title} editing is not possible`))
                }
                else {
                    handleClickOpen()
                }
            }} disableRipple>
                <ModeEditRoundedIcon fontSize='small' className='m-2' />
                Edit
            </MenuItem>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                className='w-100'
                fullWidth
                maxWidth="md"
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Edit Event</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className='flex flex-column'>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Event Name:</label>
                                    <input value={eventName} onChange={(e) => {
                                        setEventName(e.target.value)
                                    }}></input>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <AutoCompletePeople people={studentsList} list={studentsList.filter((elm:any) => {
                                        if(props.event.details.participants.filter((participant:any) => participant.Student_ID && participant.Student_ID === elm.user.Student_ID).length > 0){
                                            return elm
                                        }
                                    })
                                        } admin={userDetails} valueChange={(participants: any) => {
                                        setPartcipantList([...participants])
                                    }}></AutoCompletePeople>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Location:</label>
                                    <input value={location} onChange={(e) => {
                                        setLocation(e.target.value)
                                    }}></input>
                                </div>
                                <div className='flex justify-content-between'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <div className='flex flex-column m-2 w-50'>
                                            <label className='required'>From</label>
                                            <DateTimePicker
                                                value={from}
                                                minDateTime={dayjs(new Date())}
                                                onChange={(newValue: Dayjs | null) => {
                                                    setFrom(newValue)
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </div>
                                        <div className='flex flex-column m-2 w-50'>
                                            <label className='required'>To</label>
                                            <DateTimePicker
                                                value={to}
                                                minDateTime={dayjs(from ? from : undefined)}
                                                onChange={(newValue: Dayjs | null) => {
                                                    setTo(newValue)
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </div>
                                    </LocalizationProvider>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label className=''>Meeting URL:</label>
                                    <input value={meetingUrl} onChange={(e) => {
                                        setMeetingUrl(e.target.value)
                                    }}></input>
                                </div>
                            </div>
                        </div>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        onClick={handleSubmit}
                        startIcon={<AddHomeRoundedIcon />}
                        variant="contained"
                         autoFocus
                    >
                        Edit Meeting
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}